export const DEFAULT_SUPPORTED_LOCALE = "en";
export const SUPPORTED_LOCALES = [
  "pt",
  "pt-br",
  "es",
  "es-do",
  "es-mx",
  "es-pr",
  "en",
  "en-au",
  "en-ca",
  "en-ie",
  "en-il",
  "en-in",
  "en-nz",
  "en-sg",
  "en-tt",
  "he",
];

export type SupportedLocalesType = (typeof SUPPORTED_LOCALES)[number];

export const getSystemLocaleOrDefault = (locale?: string): SupportedLocalesType => {
  if (!locale) return DEFAULT_SUPPORTED_LOCALE;

  if (SUPPORTED_LOCALES.includes(locale as SupportedLocalesType)) {
    return locale as SupportedLocalesType;
  } else {
    const firstTwoLetters = locale.split("-")[0];
    return SUPPORTED_LOCALES.includes(firstTwoLetters) ? firstTwoLetters : DEFAULT_SUPPORTED_LOCALE;
  }
};
